"use client";
import React from "react";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
const PrSkeletonFlagged = () => {
  const [showSkeleton, setShowSkeleton] = React.useState(false);
  React.useEffect(() => {
    const providerresultloading = (event: boolean) => {
      setShowSkeleton(event);
    };
    emitter.on("providerresultloading", providerresultloading);
    return () => {
      emitter.off("providerresultloading", providerresultloading);
    };
  }, []);
  if (!showSkeleton) return null;
  return (
    <>
      {showSkeleton && (
        <section className="bg-white ">
          <div className="max-w-container mx-auto px-[16px] xl:px-[0]">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  px-[10px] gap-[20px]">
              {/* card  */}
              {Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={index}
                  className="flex flex-col rounded-[16px] overflow-hidden bg-white shadow-custom-3 border border-grey-200"
                >
                  <div className="flex justify-end h-[72px] p-[16px] bg-blue-100">
                    <span className="skeleton skeleton-text-animated flex max-w-[40px] min-h-[40px] rounded-[50px] !m-0"></span>
                  </div>
                  <div className="p-[16px]">
                    <div className="min-h-[240px] gap-[16px] flex flex-col">
                      <div className="flex flex-col">
                        <span className="skeleton skeleton-text-animated flex w-full"></span>
                        <span className="skeleton skeleton-text-animated flex max-w-[90%]"></span>
                        <span className="skeleton skeleton-text-animated flex max-w-[60%]"></span>
                      </div>

                      <div className="flex flex-col">
                        <span className="skeleton skeleton-text-animated flex w-full"></span>
                        <span className="skeleton skeleton-text-animated flex max-w-[90%]"></span>
                        <span className="skeleton skeleton-text-animated flex max-w-[60%]"></span>
                      </div>
                    </div>
                    <div className="">
                      <span className="skeleton skeleton-text-animated flex w-full min-h-[37px]"></span>
                      <span className="skeleton skeleton-text-animated flex w-full min-h-[37px]"></span>
                      <span className="skeleton skeleton-text-animated flex w-full min-h-[37px]"></span>
                      <span className="skeleton skeleton-text-animated flex w-full min-h-[37px]"></span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default PrSkeletonFlagged;
